export const VertebralLevels = {
  1: 'C1',
  2: 'C2',
  3: 'C3',
  4: 'C4',
  5: 'C5',
  6: 'C6',
  7: 'C7',
  8: 'T1',
  9: 'T2',
  10: 'T3',
  11: 'T4',
  12: 'T5',
  13: 'T6',
  14: 'T7',
  15: 'T8',
  16: 'T9',
  17: 'T10',
  18: 'T11',
  19: 'T12',
  20: 'L1',
  21: 'L2',
  22: 'L3',
  23: 'L4',
  24: 'L5',
  25: 'L6',
  26: 'S1',
  27: 'S2',
  28: 'S3',
  29: 'Ilium'
} as const;

export const ProcedureTypes = {
  'ACDF (Anterior Cervical Discectomy and Fusion)': 'ACDF',
  'ADR (Anterior Cervical Disc Replacement)': 'ADR',
  'ALIF (Anterior Lumbar Interbody Fusion)': 'ALIF',
  'Anterior Corpectomy with Cage Reconstruction': 'Anterior Corpectomy with Cage Reconstruction',
  'Anterior Debridement and Fusion (infection)': 'Anterior Debridement and Fusion (infection)',
  'Anterior Lumbar Disc Replacement': 'Anterior Lumbar Disc Replacement',
  'Combined Anterior–Posterior Deformity Correction': 'Combined Anterior–Posterior Deformity Correction',
  'Combined Anterior–Posterior Reconstruction': 'Combined Anterior–Posterior Reconstruction',
  'Endoscopic Discectomy': 'Endoscopic Discectomy',
  'MIS TLIF (MIS Transforaminal Lumbar Interbody Fusion)': 'MIS TLIF',
  'MIS Tubular Decompression': 'MIS Tubular Decompression',
  'OLIF (Lateral Oblique Lumbar Interbody Fusion)': 'OLIF',
  'PCF (Posterior Cervical Fusion)': 'PCF',
  'PLIF (Posterior Posterior Lumbar Interbody Fusion)': 'PLIF',
  'Posterior Corpectomy': 'Posterior Corpectomy',
  'Posterior Debridement and Fusion (infection)': 'Posterior Debridement and Fusion (infection)',
  'Posterior Discectomy': 'Posterior Discectomy',
  'Posterior En Bloc Tumor Resection': 'Posterior En Bloc Tumor Resection',
  'Posterior Foraminotomy': 'Posterior Foraminotomy',
  'Posterior Kyphosis Correction Fusion': 'Posterior Kyphosis Correction Fusion',
  'Posterior Laminectomy': 'Posterior Laminectomy',
  'Posterior Laminotomy': 'Posterior Laminotomy',
  'Posterior Microdiscectomy': 'Posterior Microdiscectomy',
  'Posterior Pedicle Screw Fixation (fracture)': 'Posterior Pedicle Screw Fixation (fracture)',
  'Posterior Posterolateral Fusion (PLF)': 'PLF',
  'Posterior Scoliosis Fusion': 'Posterior Scoliosis Fusion',
  'Posterior Thoracic Fusion': 'Posterior Thoracic Fusion',
  'PSIF (Posterior Sacroiliac Fusion)': 'PSIF',
  'PSO (Posterior Pedicle Subtraction Osteotomy)': 'PSO',
  'SPO (Posterior Smith-Petersen Osteotomy)': 'SPO',
  'TLIF (Posterior Transforaminal Lumbar Interbody Fusion)': 'TLIF',
  'VCR (Posterior Vertebral Column Resection)': 'VCR',
  'XLIF / DLIF (Lateral Extreme Lateral Interbody Fusion)': 'XLIF / DLIF',
} as const;

export interface SiteModel {
  siteId: string;
  siteCode: string;
  siteName: string;
};

export interface CaseDetail {
  caseId: string;
  caseDate: string;
  caseFolder: string;
  dataBucket: string;
  isRevision: boolean;
  isNavigated: boolean;
  isStaged: boolean;
  createdBy: string;
  updatedBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CaseDetailAddDTO {
  caseId: string;
  caseDate: string;
  isRevision: boolean;
  isNavigated: boolean;
  isStaged: boolean;
  procedures: CaseProcedureAddDTO[];
}

export interface CaseProcedureAddDTO {
  locusEnd: string;
  locusStart: string;
  procedureType: string;
}

export interface CaseFolder {
  siteCode: string;
  folderName: string;
  lastModifiedDate: Date | undefined;
}

export interface CaseFolderObject {
  objectKey: string;
  filePathSansCaseFolder: string;
  lastModified: Date | undefined;
  size: number | undefined;
  sizeDesc: string;
  isFolder: boolean;
  isSubFolder: boolean; // indicates if this folder is a subfolder
}

export interface PresignedPostData {
  uploadUrl: string;
  uploadFields: Record<string, string>;
}

export interface UploadInitResponse {
  uploadId: string;
  partSize: number;
  objectKey: string;
}
